module.exports = __webpack_public_path__ + "static/media/wine.e32f5a92.svg";